import {useMe} from '@features/user/queries/useMe.ts'

export const useFloorPlanOptin = () => {
    const {data} = useMe()

    const isOptedIn = data?.is3dScanEligible === true
    const isVisible = data?.isFloorPlanVisible === true

    return {
        isOptedIn,
        isVisible,
        // Show the banner only once the user is loaded, so it does not flash
        // for opted-in photographers while the request is in flight. Gated on
        // isFloorPlanVisible so home consultants never see the opt-in.
        isUndecided: data != null && isVisible && !isOptedIn
    }
}
